import * as propTypes from 'prop-types';
import * as React from 'react';
import { CTA } from '../../components/CTA';
import { __ } from '../../helpers/TranslationService';

interface IProps {
    onClick: (channel: string) => void;
    channel: string;
    isFormValid?: boolean;
    buttonText?: string;
}

export class SubmitButton extends React.Component<IProps, {}> {
    static contextTypes = {
        track: propTypes.func,
    };

    onClick = (channel: string) => {
        this.props.onClick(channel);
        if (this.context.track && this.props.isFormValid) {
            const channel = this.props.channel;
            this.context.track({
                category: channel,
                action: `${channel} submit button`,
                label: 'service',
            });
        }
    };

    render() {
        const buttonText = this.props.buttonText || __('Send Request', 'dreamlines');
        return (
            <CTA onClick={() => this.props.onClick(this.props.channel)}>
                <span>{buttonText}</span>
            </CTA>
        );
    }
}
